import { Prices } from '@features/price-graph';

export const isSelectedOnlyDepartureDate = (selectedDates: Date[]) => selectedDates[0] && !selectedDates[1];

export const getMinMaxPrice = (prices: Prices) => {
	let minPrice: number = null;
	let maxPrice: number = null;

	if (prices) {
		for (const value of Object.values(prices)) {
			if (value.price) {
				if (!minPrice || value.price.amount < minPrice) {
					minPrice = value.price.amount;
				}

				if (!maxPrice || value.price?.amount > maxPrice) {
					maxPrice = value.price.amount;
				}
			}
		}
	}

	return [minPrice, maxPrice];
};
